var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBusiness(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .business-1 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .business-1, .business-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "business-1",
    d: "m43.64,35.79v1.79c0,1.44-1.17,2.61-2.61,2.61H8.97c-1.44,0-2.61-1.17-2.61-2.61v-1.79"
  }), /*#__PURE__*/React.createElement("line", {
    className: "business-1",
    x1: 15.38,
    y1: 38.15,
    x2: 34.62,
    y2: 38.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "business-1",
    d: "m42.39,15.59H7.61c-1.44,0-2.61,1.17-2.61,2.61v1.98l17.13,7.62v-1.52h5.73v1.52l17.13-7.62v-1.98c0-1.44-1.17-2.61-2.61-2.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "business-1",
    points: "22.13 29.97 24.3 32.14 25.7 32.14 27.87 29.97 27.87 26.29 22.13 26.29 22.13 29.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "business-1",
    d: "m18.46,15.59v-2.08c0-2.05,1.66-3.71,3.71-3.71h5.66c2.05,0,3.71,1.66,3.71,3.71v2.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "business-1",
    x: 22.78,
    y: 15.59,
    width: 4.44,
    height: 10.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "business-1",
    d: "m27.87,27.81v2.17l-2.17,2.17h-1.4l-2.17-2.17v-2.17l-17.13-7.62v13.34c0,1.44,1.17,2.61,2.61,2.61h34.78c1.44,0,2.61-1.17,2.61-2.61v-13.34l-17.13,7.62Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "business-2",
    width: 50,
    height: 50
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusiness);
export default __webpack_public_path__ + "static/media/icon-business.873afeec0ad0dff961b7f2f886f62c62.svg";
export { ForwardRef as ReactComponent };